import { createApp } from 'vue'
import { createHead } from '@unhead/vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'
import './styles/main.css'

const app = createApp(App)
const head = createHead()

app.use(head)
app.use(createPinia())
app.use(router)
app.use(vuetify)

app.mount('#app')
